import React, { ReactNode } from "react";
import styled from "styled-components";
import InfiniteScroll from "react-infinite-scroll-component";
import InfinityListLoader from "../../common/components/InfinityListLoader/InfinityListLoader";

const Wrapper = styled.div`
  min-height: 540px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    min-height: unset;
  }
`;

const TrackList = styled.div`
  display: grid;
  column-gap: 31px;
  row-gap: 48px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    grid-template-columns: auto;
  }
`;

interface ITracksProps<ListItemType> {
  listings: ListItemType[];
  fetchNextPage: () => void;
  complete: boolean;
  emptyStateComponent: ReactNode;
  isLoading: boolean;
  renderItem: (item: ListItemType) => ReactNode;
  className?: string;
}

function UserTrackList<ListItemType>({
  fetchNextPage,
  complete,
  emptyStateComponent,
  listings = [],
  isLoading,
  renderItem,
  className,
}: ITracksProps<ListItemType>) {
  const renderContent = () => {
    if (isLoading && listings.length === 0) {
      return <InfinityListLoader />;
    }

    if (!isLoading && complete && listings.length === 0) {
      return <>{emptyStateComponent}</>;
    }

    return (
      <InfiniteScroll
        next={fetchNextPage}
        hasMore={!complete}
        loader={<InfinityListLoader />}
        dataLength={listings?.length}
      >
        <TrackList className={className}>{listings?.map(renderItem)}</TrackList>
      </InfiniteScroll>
    );
  };

  return <Wrapper>{renderContent()}</Wrapper>;
}

export default UserTrackList;
